const getters = {
    dm: state => state.User.dm
};
export default getters